import { render, staticRenderFns } from "./ServicepointsFilter.vue?vue&type=template&id=04d554ea&scoped=true"
import script from "./ServicepointsFilter.vue?vue&type=script&lang=ts"
export * from "./ServicepointsFilter.vue?vue&type=script&lang=ts"
import style0 from "./ServicepointsFilter.vue?vue&type=style&index=0&id=04d554ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d554ea",
  null
  
)

export default component.exports